import React from 'react';
import ContactSection from '../Components/ContactSection';

export default function Contact() {
  return (
    <div>
      <ContactSection />
    </div>
  );
}
